import React, { memo, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "@mui/material/Button";
import {
  Card,
  CardContent,
  Grid,
  CardActions,
  TableRow,
  TableCell,
  Alert,
  Box,
  Dialog,
  DialogContent,
  Stack,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import "../../styles/main.css";
import {
  preevaluacionCliente,
  preevaluacionClienteCredito,
} from "../../services/creditoServices";
import {
  obtenerPersonaCf,
  validarDocumentosCF,
} from "app/modules/app-cliente/services/clienteService";
import {
  grabarAceptacion,
  obtenerAceptacion,
} from "app/modules/app-evaluacion/services/evaluacionServices";
import PoliticsDetails from "../../components/PoliticsDetails";
import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";
import BuscadorPreevCliente from "../../containers/BuscadorPreevCliente";

function PreevaluacionContent() {
  const [mostrarAprobado, setMostrarAprobado] = useState(false);
  const [mostrarNegado, setMostrarNegado] = useState(false);
  const [identificacionCliente, setIdentificacionCliente] = useState("");
  const [mensajeCliente, setMensajeCiente] = useState("");
  const [terminosYCondiciones, setTerminosYCondiciones] = useState("");
  const [politicasPrivacidad, setpoliticasPrivacidad] = useState("");
  const [aceptadoTyC, setAceptadoTyC] = useState(false);
  const [aceptadoPPR, setAceptadoPPR] = useState(false);
  const [datosCli, setDatosCli] = useState({});
  const { authUser } = useSelector(({ auth }) => auth);
  const [openTyC, setOpenTyC] = useState(false);
  const [openPPR, setOpenPPR] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingPreevaluar, setLoadingPreevaluar] = useState(false);
  const history = useHistory();

  const [statesLegalDocuments, setStatesLegalDocuments] = useState({
    stateTYC: false,
    statePPR: false,
  });

  const [openPoliticsDetails, setOpenPoliticsDetails] = useState(false);
  const [clientInformation, setClientInformation] = useState({});
  const [emailVerificacion, setEmailVerificacion] = useState({});
  const [flujoFinal, setFlujoFinal] = useState("");
  const [datosPreevaluacion, setDatosPreevaluacion] = useState({});

  const [open, setOpen] = useState(false); // puedes controlar esto desde fuera
  const [continuaProceso, setContinuaProceso] = useState(false);

  const handleClose = (_, reason) => {
    // Esto permite cerrar tanto al hacer clic fuera como con ESC
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      setOpen(false);
    }
  };

  const traerIdentificacion = (id) => async () => {
    if (!id) {
      alert("Ingrese un numero de cedula");
    } else {
      if (id.length === 10) {
        setAceptadoTyC(false);
        setAceptadoPPR(false);
        setMostrarAprobado(false);
        setMostrarNegado(false);
        setIdentificacionCliente(id);
        validacionInicialCliente(id);
      } else {
        alert("Ingrese un numero de cedula valido");
      }
    }
  };

  const traerDatosPreev = (datos) => async () => {
    if (!datos.identificacion) {
      alert("Ingrese un numero de cedula");
    } else {
      if (datos.identificacion.length === 10) {
        setAceptadoTyC(false);
        setAceptadoPPR(false);
        setMostrarAprobado(false);
        setMostrarNegado(false);
        setIdentificacionCliente(datos.identificacion);
        preevaluacionClienteSolicitud(datos);
      } else {
        alert("Ingrese un numero de cedula valido");
      }
    }
  };

  const validarIdentificacionCF = (id) => async () => {
    if (!id) {
      alert("Ingrese un numero de cedula");
    } else {
      if (id.length === 10) {
        setMostrarAprobado(false);
        setMostrarNegado(false);
        setAceptadoTyC(false);
        setAceptadoPPR(false);
        validacionTyC(id);
      } else {
        alert("Ingrese un numero de cedula valido");
      }
    }
  };

  // const validacionTyC = async (identificacion) => {
  //   const today = new Date().toLocaleString("en-US");

  //   const respInfoAceptacion = await obtenerAceptacion(identificacion);
  //   if (respInfoAceptacion.state && respInfoAceptacion.data.enviaDatos) {
  //     alert("Cliente FIRMADOS los documentos de TyC, puede continuar");
  //     setAceptadoPPR(true);
  //     setAceptadoTyC(true);
  //   } else {
  //     const cli = {
  //       identificacion: identificacion,
  //       fechaConsulta: today,
  //       usuario: authUser.key,
  //       estacion: authUser.estacion,
  //       enviaDatos: false,
  //       tcu: false,
  //       ppr: false,
  //     };
  //     try {
  //       const respObetenerPersona = await obtenerPersonaCf(identificacion);
  //       if (respObetenerPersona.state) {
  //         //setDatosCli({ cliente: respObetenerPersona.data.statePerson});
  //         cli.esCliente = respObetenerPersona.data.statePerson;
  //       } else {
  //         console.log(respObetenerPersona.message);
  //       }

  //       if (cli.esCliente) {
  //         const respValidarDocumentos = await validarDocumentosCF(
  //           identificacion
  //         );
  //         if (respValidarDocumentos.state) {
  //           const boolString = "true";
  //           //setDatosCli({ documentosFirmados: boolString === respValidarDocumentos.data.stateDocuments});
  //           cli.documentosFirmados =
  //             boolString === respValidarDocumentos.data.stateDocuments;

  //           if (cli.documentosFirmados) {
  //             alert("Cliente FIRMADOS los documentos de TyC, puede continuar");
  //             setAceptadoPPR(true);
  //             setAceptadoTyC(true);
  //           } else {
  //             alert("Cliente debe Firmar documentos de TyC");
  //             const documentos = respValidarDocumentos.data.documents;
  //             console.log(documentos);
  //             if (documentos === null) {
  //               const respDocTcu = await obtenerDocumentoLegal("TCD");
  //               if (respDocTcu.state) {
  //                 setTerminosYCondiciones(respDocTcu.data);
  //               } else {
  //                 alert(respDocTcu.message);
  //               }

  //               const respDocPpr = await obtenerDocumentoLegal("PPR");
  //               if (respDocPpr.state) {
  //                 setpoliticasPrivacidad(respDocPpr.data);
  //               } else {
  //                 alert(respDocPpr.message);
  //               }

  //               setOpenTyC(true);
  //               setOpenPPR(true);
  //             } else {
  //               if (documentos.length < 2) {
  //                 const tieneTCU = documentos.some(
  //                   (doc) => doc.contentType === "TCD"
  //                 );
  //                 const tienePPR = documentos.some(
  //                   (doc) => doc.contentType === "PPR"
  //                 );
  //                 if (!tieneTCU) setAceptadoTyC(true);

  //                 if (!tienePPR) setAceptadoPPR(true);
  //               }
  //               documentos.map((doc) => {
  //                 if (doc.contentType === "TCD") {
  //                   setTerminosYCondiciones(doc.content);
  //                   setOpenTyC(true);
  //                 }
  //                 if (doc.contentType === "PPR") {
  //                   setpoliticasPrivacidad(doc.content);
  //                   setOpenPPR(true);
  //                 }
  //               });
  //             }
  //           }
  //         } else {
  //           alert(respValidarDocumentos.message);
  //         }
  //       } else {
  //         alert("No es cliente CF debe Firmar Documentos");
  //         cli.documentosFirmados = false;
  //         const respDocTcu = await obtenerDocumentoLegal("TCD");
  //         if (respDocTcu.state) {
  //           setTerminosYCondiciones(respDocTcu.data);
  //         } else {
  //           alert(respDocTcu.message);
  //         }

  //         const respDocPpr = await obtenerDocumentoLegal("PPR");
  //         if (respDocPpr.state) {
  //           setpoliticasPrivacidad(respDocPpr.data);
  //         } else {
  //           alert(respDocPpr.message);
  //         }

  //         setOpenTyC(true);
  //         setOpenPPR(true);
  //       }
  //     } catch (e) {
  //       alert(e);
  //     }
  //     setDatosCli({ ...cli });
  //   }
  // };

  const validacionTyC = async (identificacion) => {
    setLoading(true);
    const today = new Date().toLocaleString("en-US");

    try {
      const respInfoAceptacion = await obtenerAceptacion(identificacion);

      if (respInfoAceptacion.state && respInfoAceptacion.data.enviaDatos) {
        alert(
          "Cliente ya tiene firmado los documentos de Términos y Condiciones. Puede continuar"
        );

        setOpenPoliticsDetails(false);
        //setModalClient((args) => ({ ...args, state: false }));
        setStatesLegalDocuments((args) => ({
          ...args,
          statePPR: true,
          stateTYC: true,
        }));

        setAceptadoPPR(true);
        setAceptadoTyC(true);
        setLoading(false);

        return;
      }
    } catch (error) {
      console.log(error);
    }

    const cli = {
      identificacion: identificacion,
      fechaConsulta: today,
      idGrupo: authUser.usuarioFlujos[0].idGrupo,
      usuario: authUser.key,
      estacion: authUser.estacion,
      enviaDatos: false,
      tcu: false,
      ppr: false,
      bur: true,
      //esCliente:false
    };

    try {
      if (authUser.usuarioFlujos[0].idGrupo === 1) {
        const respObetenerPersona = await obtenerPersonaCf(identificacion);
        if (respObetenerPersona.state) {
          //setDatosCli({ cliente: respObetenerPersona.data.statePerson});
          cli.esCliente = respObetenerPersona.data.statePerson;
        } else {
          console.log(respObetenerPersona.message);
        }

        if (!cli.esCliente) {
          alert(
            "Cliente tiene pendiente la aceptacion de Términos y Condiciones"
          );

          /* permite activar los modales de los documentos legales e impide 
        la llamada a los servicio cuando no es necesario */
          setAceptadoTyC(true);
          setAceptadoPPR(true);

          /* cierra el modal de identificacion */
          // setModalClient((args) => ({ ...args, state: false }));

          /* settea los estados de los documentos */
          setStatesLegalDocuments((args) => ({
            ...args,
            statePPR: false,
            stateTYC: false,
          }));

          /* permite abrir el modal PoliticsDetails cuado es necesario firmar los documentos */
          setOpenPoliticsDetails(true);

          //return;
        }

        if (cli.esCliente) {
          const respValidarDocumentos = await validarDocumentosCF(
            identificacion
          );

          if (respValidarDocumentos.state) {
            const boolString = "true";

            cli.documentosFirmados =
              boolString === respValidarDocumentos.data.stateDocuments;

            if (cli.documentosFirmados) {
              alert(
                "Cliente ya tiene firmado los documentos de Términos y Condiciones. Puede continuar"
              );

              setOpenPoliticsDetails(false);
              setLoading(false);

              //setModalClient((args) => ({ ...args, state: false }));
              setStatesLegalDocuments((args) => ({
                ...args,
                statePPR: true,
                stateTYC: true,
              }));

              setAceptadoPPR(true);
              setAceptadoTyC(true);
            } else {
              alert(
                "Cliente tiene pendiente la aceptacion de Términos y Condiciones"
              );
              const documentos = respValidarDocumentos.data.documents;

              /* para habilitar los modales de politicas documents */
              setAceptadoPPR(true);
              setAceptadoTyC(true);

              if (documentos === null) {
                /* cierra el modal de identificacion */
                //setModalClient((args) => ({ ...args, state: false }));

                /* permite abrir el modal PoliticsDetails cuado es necesario firmar los documentos */
                setOpenPoliticsDetails(true);

                /* settea los estados de los documentos */
                setStatesLegalDocuments((args) => ({
                  ...args,
                  statePPR: false,
                  stateTYC: false,
                }));
              } else {
                if (documentos.length < 2) {
                  const tieneTCU = documentos.some(
                    (doc) => doc.contentType === "TCD"
                  );
                  const tienePPR = documentos.some(
                    (doc) => doc.contentType === "PPR"
                  );
                  if (!tieneTCU) {
                    setStatesLegalDocuments((args) => ({
                      ...args,
                      statePPR: false,
                      stateTYC: true,
                    }));
                  }

                  if (!tienePPR) {
                    setStatesLegalDocuments((args) => ({
                      ...args,
                      statePPR: true,
                      stateTYC: false,
                    }));
                  }

                  /* cierra el modal de identificacion */
                  //setModalClient((args) => ({ ...args, state: false }));

                  /* permite abrir el modal PoliticsDetails cuado es necesario firmar los documentos */
                  setOpenPoliticsDetails(true);
                } else {
                  setStatesLegalDocuments((args) => ({
                    ...args,
                    statePPR: false,
                    stateTYC: false,
                  }));

                  /* cierra el modal de identificacion */
                  //setModalClient((args) => ({ ...args, state: false }));

                  /* permite abrir el modal PoliticsDetails cuado es necesario firmar los documentos */
                  setOpenPoliticsDetails(true);
                }
              }
            }
          } else {
            alert(respValidarDocumentos.message);
          }
        }
      } else {
        cli.esCliente = false;
        cli.enviaDatos = true;
        alert(
          "Cliente tiene pendiente la aceptacion de Términos y Condiciones"
        );

        setAceptadoTyC(true);
        setAceptadoPPR(true);

        /* settea los estados de los documentos */
        setStatesLegalDocuments((args) => ({
          ...args,
          statePPR: false,
          stateTYC: false,
        }));

        setOpenPoliticsDetails(true);
      }
    } catch (e) {
      alert(e);
    }

    setClientInformation(cli);
  };

  const grabarDatosAceptacion = async () => {
    try {
      const srvGrabarAceptacion = await grabarAceptacion(datosCli);
      if (srvGrabarAceptacion.state) {
        console.log(srvGrabarAceptacion.data);
      } else {
        alert(srvGrabarAceptacion.message);
      }
    } catch (e) {
      alert(e);
    }
  };

  const validacionInicialCliente = async (identificacion) => {
    setLoadingPreevaluar(true);
    const validarBuro = true;
    try {
      var resp = await preevaluacionCliente(
        identificacion,
        authUser.key,
        authUser.estacion,
        validarBuro
      );
      if (resp.state) {
        console.log(resp);
        if (resp.state) {
          if (resp.data.validacion) {
            //console.log(resp.data.mensaje);
            setMensajeCiente(resp.data.mensaje);
            setMostrarAprobado(true);
            setLoadingPreevaluar(false);
          } else {
            setMensajeCiente(resp.data.mensaje);
            setMostrarNegado(true);
            setLoadingPreevaluar(false);
          }
        } else {
          console.log(resp.message);
          setLoadingPreevaluar(false);
        }
      }
    } catch (e) {
      console.log(e);
      setLoadingPreevaluar(false);
    }
  };

  const preevaluacionClienteSolicitud = async (datos) => {
    console.log(datos);

    setLoadingPreevaluar(true);

    const validarBuro = true;
    const datosPreev = {
      identificacion: datos.identificacion,
      usuario: authUser.key,
      local: authUser.oficina,
      origen: "SCS",
      dactilar: datos.codDactilar,
      celular: datos.celularCliente,
      email: datos.mailCliente,
      estacion: authUser.estacion,
    };

    try {
      var resp = await preevaluacionClienteCredito(datosPreev);
      if (resp.state) {
        // console.log(resp);
        const flujoRespuesta = resp.data.datosPreevaluacion.flujoFinal;
        setFlujoFinal(resp.data.datosPreevaluacion.flujoFinal);
        //setMontoSugerido(resp.data.datosMontoSugerido.valor)
        setDatosPreevaluacion(resp.data);
        let monto, montoAbastos;
        switch (flujoRespuesta) {
          case "NEGADO":
            setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
            setMostrarNegado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(false);
            setOpen(true);

            break;
          case "REVISION":
            monto =
              resp.data.datosMontoSugerido.valor > 2500
                ? 2500
                : resp.data.datosMontoSugerido.valor < 0
                ? 0
                : resp.data.datosMontoSugerido.valor;

            setMensajeCiente(
              "Preevaluacion exitosa, continua con la solicitud."
            );
            setMostrarAprobado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(true);
            setOpen(true);

            break;
          case "EXPRESS":
            monto =
              resp.data.datosMontoSugerido.valor > 2500
                ? 2500
                : resp.data.datosMontoSugerido.valor < 0
                ? 0
                : resp.data.datosMontoSugerido.valor.toFixed(0);

            montoAbastos = resp.data.datosMontoSugerido.valorAbastos;
            const textAbastos =
              resp.data.datosPreevaluacion.idGrupo === 1
                ? ` y para Abastos de $${montoAbastos.toFixed(0)}`
                : ``;
            setMensajeCiente(
              `Felicidades tienes un monto preaprobado para Mercancias Generales de $${monto}${textAbastos} y puedes usarlos hoy mismo.`
            );
            setMostrarAprobado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(true);
            setOpen(true);

            break;
          case "DEVUELTA":
            setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
            setMostrarAprobado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(true);
            setOpen(true);

            break;
          case "SolicitudActiva":
            setMensajeCiente(resp.data.datosPreevaluacion.mensaje);
            setMostrarNegado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(false);
            setOpen(true);

            break;
          default:
            setMensajeCiente(
              "En estos momentos no podemos realizar su Preevaluación por favor intente en unos minutos."
            );
            setMostrarNegado(true);
            setLoadingPreevaluar(false);
            setContinuaProceso(false);
            setOpen(true);

            break;
        }

        // if (resp.data.validacion) {
        //   //console.log(resp.data.mensaje);
        //   setMensajeCiente(resp.data.mensaje);
        //   setMostrarAprobado(true);
        //   setLoadingPreevaluar(false);
        // } else {
        //   setMensajeCiente(resp.data.mensaje);
        //   setMostrarNegado(true);
        //   setLoadingPreevaluar(false);
        // }
      } else {
        console.log(resp.message);
        setMensajeCiente(
          "En estos momentos no podemos realizar su Preevaluación por favor intente en unos minutos."
        );
        setLoadingPreevaluar(false);
        setContinuaProceso(false);
        setOpen(true);
      }
    } catch (e) {
      console.log(e);
      setMensajeCiente(
        "En estos momentos no podemos realizar su Evaluación por favor intente en unos minutos.(E)"
      );
      setLoadingPreevaluar(false);
      setContinuaProceso(false);
      setOpen(true);
    }
  };

  const routeChange = (cambioCupo) => {
    const path = "/credito/flujop";
    history.push(path, {
      data: {
        identificacion: identificacionCliente,
        flujoFinal: flujoFinal,
        cambioCupo: cambioCupo,
        datosPreevaluacion: datosPreevaluacion,
      },
    });
  };

  const handleAceptarPPR = (valor) => async () => {
    console.log("ppr");
    setAceptadoPPR(valor);
    setDatosCli({ ...datosCli, ppr: valor });
    setOpenPPR(false);
  };

  const handleAceptarTyC = (valor) => async () => {
    console.log("tyc");
    setAceptadoTyC(valor);
    setDatosCli({ ...datosCli, tcu: valor });
    setOpenTyC(false);
  };

  useEffect(() => {
    if (aceptadoPPR & aceptadoTyC) {
      grabarDatosAceptacion();
      console.log(datosCli);
    }
  }, [datosCli]);

  const limpiar = (valor) => async () => {
    console.log(valor);
    //setLimpiar(valor);
    //setOpenTyC(false);
  };

  if (!authUser.usuarioFlujos[0]) {
    return (
      <Alert severity="error">
        <Typography>
          Estimado Usuario, usted no puede crear solicitudes de credito, para
          mayor informacion comunicarse con Soporte Técnico - Servimax.
        </Typography>
      </Alert>
    );
  }

  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Grid
          rowSpacing={4}
          spacing={5}
          justifyContent="center"
          alignItems={"center"}
          width={{ xs: 1, md: "80%", lg: "60%", xl: "50%" }}
        >
          <Grid item md={7} sm={7} xs={7}>
            <BuscadorPreevCliente
              traerDatosPreev={traerDatosPreev}
              // traerIdentificacion={traerIdentificacion}
              validarIdentificacionCF={validarIdentificacionCF}
              validado={aceptadoPPR & aceptadoTyC}
              limpiar={limpiar}
              loading={loading}
              loadingPreevaluar={loadingPreevaluar}
              idGrupo={authUser.usuarioFlujos[0].idGrupo}
            />
          </Grid>
          {/* <Grid
            hidden={!mostrarAprobado}
            item
            md={7}
            sm={7}
            xs={7}
            marginTop={5}
          >
            <Card>
              <CardContent>
                <Typography variant="body2">
                  {mensajeCliente.split("\n").map((row) => (
                    <TableRow id={row} sx={{ "& td": { border: 0 } }}>
                      <TableCell sx={{ padding: 0.7 }}>{row}</TableCell>
                    </TableRow>
                  ))}
                </Typography>
              </CardContent>
              <CardActions>
                <SCSGenericButton
                  id="continuar"
                  name="continuar"
                  variant="contained"
                  onClick={() => {
                    routeChange(false);
                  }}
                  titulo={"Continuar"}
                />
                {flujoFinal === "EXPRESS" && (
                  <SCSGenericButton
                    id="nuevoCupo"
                    name="nuevoCupo"
                    variant="contained"
                    onClick={() => {
                      routeChange(true);
                    }}
                    titulo={"Deseo mayor cupo"}
                  />
                )}
              </CardActions>
            </Card>
          </Grid>
          <Grid hidden={!mostrarNegado} item md={8} sm={8} xs={8} marginTop={5}>
            <Card>
              <CardContent>
                <Typography variant="body2">
                  {mensajeCliente.split("\n").map((row) => (
                    <TableRow id={row} sx={{ "& td": { border: 0 } }}>
                      <TableCell sx={{ padding: 0.7 }}>{row}</TableCell>
                    </TableRow>
                  ))}
                </Typography>
              </CardContent>
            </Card>
          </Grid> */}
        </Grid>
        <PoliticsDetails
          open={openPoliticsDetails}
          setOpenPoliticsDetails={setOpenPoliticsDetails}
          titulo={"Politicas de Credito Directo"}
          aceptadoTyC={aceptadoTyC}
          aceptadoPPR={aceptadoPPR}
          statesLegalDocuments={statesLegalDocuments}
          clientInformation={clientInformation}
          setLoadButtonTYC={setLoading}
        />
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: "hidden",
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: "#e9f0ffff",
            borderRadius: 4,
            p: 3,
          }}
        >
          <Card
            elevation={0}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <CardContent>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
              >
                <Box flex="1" minWidth="220px">
                  <Typography
                    variant="h2"
                    fontWeight="bold"
                    color="text.primary"
                    // gutterBottom
                  >
                    {continuaProceso
                      ? "PREEVALUACION EXITOSA"
                      : "PREEVALUACION NO EXITOSA"}
                  </Typography>
                  <Typography variant="h3" color="text.secondary" mb={2} mt={5}>
                    {mensajeCliente}
                  </Typography>
                  {continuaProceso && (
                    <Stack direction={"row"} spacing={2} mt={8}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          routeChange(false);
                        }}
                        sx={{
                          backgroundColor: "#FFFFFF",
                          color: "#000",
                          textTransform: "none",
                          fontWeight: "bold",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                          borderRadius: "9999px", // 🔘 redondeado tipo píldora
                          px: 3, // padding horizontal extra
                          "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                      >
                        Continuar
                      </Button>
                      {flujoFinal === "EXPRESS" && (
                        <Button
                          variant="contained"
                          onClick={() => {
                            routeChange(true);
                          }}
                          sx={{
                            backgroundColor: "#FFFFFF",
                            color: "#000",
                            textTransform: "none",
                            fontWeight: "bold",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                            borderRadius: "9999px", // 🔘 redondeado tipo píldora
                            px: 3, // padding horizontal extra
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                        >
                          Deseo Mayor Monto!
                        </Button>
                      )}
                    </Stack>
                  )}
                </Box>

                {/* Imagen del personaje rojo */}
                <Box
                  component="img"
                  src={`/images/logo-preev-${authUser.usuarioFlujos[0].idGrupo}.png`}
                  alt="Figura roja"
                  sx={{
                    width: 175,
                    height: "auto",
                    ml: 2,
                    mt: { xs: 2, sm: 0 },
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default memo(PreevaluacionContent);
